// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import XLSX from "xlsx";
import { Loader, Button, Label, Input } from "../../revvComponents";

// Components Imports
import { ReactSelect } from "../../commonComponents";

// ACTION IMPORTS
import { GoogleSheetActions, QuotationActions } from "../../actions";
import {
  updateDocumentComponentAction,
  executeCommand,
} from "../../actions/DocumentActions/index";
import { updateDocumentComponentService } from "../../actions/DocumentActions/services";

// Services Imports && methods

import UpdateComponentCommand from "../../commands/updateComponentCommand";

// Internal Imports
import {
  convertExcelToSectionTable,
  getColAndRowCountFromRange,
  convertSectionTableToLinkedExcel,
} from "../RevvTableV2/utils";
import {
  GOOGLE_SHEET_VIEW_CONTROL,
  COMMON,
  DOCUMENTS,
  IMAGE_URLS,
} from "../../constants";

import TableExcelUploadSizeLimitPopup from "../RevvTableV2/TableExcelUploadSizeLimitPopup";
import UploadXlsToTableCommand from "../../commands/uploadXlsToTableCommand";

const { toggleTabAndToolPanelData } = QuotationActions;
const { TABLE_TYPE } = COMMON;
const { DOCUMENT_MODE } = DOCUMENTS;
const { spreadsheetIcon } = IMAGE_URLS;

// Destructuring
const {
  fetchGoogleWorkSheet,
  setWorkSheet,
  clearSelectedGSheetData,
  reUpdateWorkSheetOptions,
  makeEmptyRange,
  updatefirstRowAsHeaderKey,
} = GoogleSheetActions;

const FORM = "FORM";

class SelectedSheetComponent extends Component {
  state = {
    loader: false,
    loaderMsg: "",
    worksheetOptions: [],
    errorMsg: "",
    isFirstRowHeader: false,
    showTableExcelSizeLimitPopup: false,
  };

  componentDidMount() {
    if (
      this.props.sheetData &&
      this.props.sheetData.data &&
      this.props.sheetData.data.attributes &&
      this.props.sheetData.data.attributes.excelSheets
    ) {
      const { sheetData } = this.props;
      const {
        data: {
          attributes: { excelSheets, autoTrim, firstRowAsHeader },
        },
      } = sheetData;
      this._onInit(excelSheets, autoTrim, firstRowAsHeader);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.excelSheetId !== this.props.excelSheetId) {
      const { sheetData } = this.props;
      const {
        data: {
          attributes: { excelSheets, firstRowAsHeader },
        },
      } = sheetData;
      this.setState({ isFirstRowHeader: firstRowAsHeader });
      this._onInit(excelSheets);
    }
    const { sheetData } = this.props;
    const {
      data: {
        attributes: { autoTrim },
      },
    } = sheetData;
    if (autoTrim) {
      this._setautoTrimMessage(GOOGLE_SHEET_VIEW_CONTROL.WARNING_MESSAGE);
    }
  }

  _setautoTrimMessageInFalseState = message => {
    if (this.state.errorMsg) {
      this.setState({
        errorMsg: message,
      });
    }
  };

  _setautoTrimMessage = message => {
    if (this.state.errorMsg === "") {
      this.setState({
        errorMsg: message,
      });
    }
  };

  _onInit = (excelSheets, autoTrim, firstRowAsHeader) => {
    if (excelSheets && excelSheets.length > 0) {
      this.setState({
        loader: true,
        loaderMsg: "Loading your sheets!",
      });
      const workSheets = [];
      excelSheets.forEach(sheet => {
        workSheets.push(sheet.sheetName);
      });
      this.setState({
        worksheetOptions: workSheets,
        fileName: excelSheets[0].fileName,
      });
      this.props.upatedExcelSheetTable(excelSheets[0].sheetName);
      this.setState({
        loader: false,
        loaderMsg: "",
      });
    }
    if (autoTrim) {
      this._setautoTrimMessage(GOOGLE_SHEET_VIEW_CONTROL.WARNING_MESSAGE);
    }
    if (firstRowAsHeader !== undefined) {
      this.setState({ isFirstRowHeader: firstRowAsHeader });
    }
  };

  _onCheckChange = value => {
    this.setState({ isFirstRowHeader: value });
  };

  _checkValidation = selectedRange => {
    const d = selectedRange;
    let finalStatus = false;

    /* later we need to improve the logic */

    // const regex = /([A-Z]+)(\d+):([A-Z]+)(\d+)/;
    // const regex = /([A-Z]+)([1-9][0-9]{0,10}+):([A-Z]+)([1-9][0-9]{0,10}+)/;
    // const regex = /([A-Z]+)([1-9][0-9]{0,}):([A-Z]+)([1-9][0-9]{0,})/;
    // finalStatus = regex.test(d);

    if (d.includes(":")) {
      const spilitedValue = d.split(/[:]/);
      if (spilitedValue.length === 2) {
        const firstBlock = spilitedValue[0].trim();
        const secBlock = spilitedValue[1].trim();
        const firstCharOfFirstBlock = firstBlock.charCodeAt(0);
        const secondCharOfSecondBlock = secBlock.charCodeAt(0);
        const firstCharStatus =
          (firstCharOfFirstBlock >= 65 && firstCharOfFirstBlock < 91) ||
          (firstCharOfFirstBlock >= 97 && firstCharOfFirstBlock < 123);
        const SecondCharStatus =
          (secondCharOfSecondBlock >= 65 && secondCharOfSecondBlock < 91) ||
          (secondCharOfSecondBlock >= 97 && secondCharOfSecondBlock < 123);
        if (
          firstCharStatus &&
          SecondCharStatus &&
          firstCharOfFirstBlock <= secondCharOfSecondBlock
        ) {
          const firstSec = firstBlock.replace(firstBlock.charAt(0), "");
          const secondSec = secBlock.replace(secBlock.charAt(0), "");
          if (
            firstSec &&
            secondSec &&
            (parseInt(firstSec.charAt(0), 10) !== 0 ||
              parseInt(secondSec.charAt(0) !== 0, 10)) &&
            // eslint-disable-next-line no-restricted-globals
            !isNaN(firstSec) &&
            // eslint-disable-next-line no-restricted-globals
            !isNaN(secondSec) &&
            parseInt(firstSec, 10) <= parseInt(secondSec, 10)
          ) {
            finalStatus = true;
          }
        }
      }
    }
    if (d) {
      if (!finalStatus) {
        this.setState({
          errorMsg: "invalid range",
        });
      } else {
        this.setState({
          errorMsg: "",
        });
      }
    } else {
      this.setState({
        errorMsg: "",
      });
    }
    return finalStatus;
  };

  _checkGivenRangeExist = (selectedRange, originalRange) => {
    if (!selectedRange || !originalRange) return false;
    if (!this._checkValidation(selectedRange)) {
      this.setState({
        errorMsg: "Invalid range",
      });
      return true;
    }
    const { endRow: originalEndRow, endCol: originalEndCol } =
      getColAndRowCountFromRange(originalRange);
    const { endRow, endCol } = getColAndRowCountFromRange(selectedRange);
    if (originalEndRow < endRow || originalEndCol < endCol) {
      this.setState({
        errorMsg: `Selected Range is not valid for this sheet, please select in ${originalRange} this range`,
      });
      return true;
    }
    this.setState({
      errorMsg: "",
    });
    return false;
  };

  _convertExcelSheetData = () => {
    const { sheetData, selectedRangeValue, selectedWorkSheet } = this.props;
    const {
      data: {
        attributes: { excelSheets },
      },
    } = sheetData;
    const updatedTableData = convertExcelToSectionTable(
      sheetData,
      excelSheets,
      selectedWorkSheet,
      selectedRangeValue,
      this.state.isFirstRowHeader,
    );
    const newSection = {
      ...this.props.sheetData,
      data: updatedTableData,
    };
    this.props.updateDocumentComponentAction(newSection);
    const updateCommand = new UpdateComponentCommand({
      mode: this.props.mode,
      docID: this.props.docID,
      isTemplateTypeForm: this.props.isTemplateTypeForm,
      // components: { ...this.props.components },
      oldSection: sheetData,
      clickedActiveComponentId: this.props.clickedActiveComponentId,
      updatedSection: newSection,
      updateDocumentComponentAction: this.props.updateDocumentComponentAction,
      updateSectionService: updateDocumentComponentService,
      change: true,
      // updateDocumentClickedComponentID:
      //   this.props.updateDocumentClickedComponentID,
      forceUpdateEditorSectionIdAction:
        this.props.forceUpdateEditorSectionIdAction,
      toggleCoverpageView: this.props.toggleCoverpageView,
      updateActiveComponentMeta: this.props.updateActiveComponentMeta,
    });
    this.props.executeCommand(updateCommand);
  };

  _getSynchButtonAndCheckbox = () => {
    let component = null;
    const {
      data: {
        attributes: { excelSheets, currentSheetName },
      },
    } = this.props.sheetData;
    let originalRange;
    excelSheets.forEach(sheet => {
      if (sheet.sheetName === currentSheetName) {
        originalRange = sheet.range;
      }
    });
    component = (
      <Fragment>
        <div className="excelsheet-selected-checkbox">
          <Input
            type="checkbox"
            checked={this.state.isFirstRowHeader}
            onChange={e => this._onCheckChange(e.target.checked)}
            data-test="selectedsheetcomponent-checkbox"
          />
          <span className="excelsheet-selected-checkbox-label">
            Use first row as the header
          </span>
        </div>
        <div className="excelsheet-selected-checkbox">
          <Button
            data-test="selectedsheetcomponent-syncselectedsheet"
            onClick={() =>
              !this._checkGivenRangeExist(
                this.props.selectedRangeValue,
                originalRange,
              )
                ? this._convertExcelSheetData()
                : {}
            }
            disabled={!this.props.selectedWorkSheet}>
            Sync selected sheet
          </Button>
        </div>
      </Fragment>
    );
    return component;
  };

  _saveTable = tableData => {
    // const { tableData } = this.state;
    const newSection = {
      ...this.props.sheetData,
      data: tableData,
    };
    this.props.updateDocumentComponentAction(newSection);
    const updateCommand = new UpdateComponentCommand({
      mode: this.props.mode,
      docID: this.props.docID,
      isTemplateTypeForm: this.props.isTemplateTypeForm,
      // components: { ...this.props.components },
      oldSection: this.props.sheetData,
      clickedActiveComponentId: this.props.clickedActiveComponentId,
      updatedSection: newSection,
      updateDocumentComponentAction: this.props.updateDocumentComponentAction,
      updateSectionService: updateDocumentComponentService,
      change: true,
      // updateDocumentClickedComponentID:
      //   this.props.updateDocumentClickedComponentID,
      // undoComponentUpdate: this.props.undoComponentUpdate,
      forceUpdateEditorSectionIdAction:
        this.props.forceUpdateEditorSectionIdAction,
      toggleCoverpageView: this.props.toggleCoverpageView,
      updateActiveComponentMeta: this.props.updateActiveComponentMeta,
    });
    this.props.executeCommand(updateCommand);
  };

  _selectNewFile = () => {
    // Opening dialog box and selecting file
    const uploadedExcelData = [];
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.setAttribute("id", "upload-excel-file");
    fileSelector.setAttribute("accept", ".xls,.xlsx");
    // fileSelector.setAttribute("multiple", "multiple");
    fileSelector.click();
    if (fileSelector) {
      fileSelector.addEventListener("change", event => {
        const reader = new FileReader();
        const checkType = !!reader.readAsBinaryString;
        const file = event.target.files[0];
        if (file.size > 1000000) {
          this.setState({ showTableExcelSizeLimitPopup: true });
        } else {
          reader.readAsBinaryString(file);
          reader.onload = e => {
            const workbook = XLSX.read(e.target.result, {
              type: checkType ? "binary" : "array",
            });
            if (workbook) {
              workbook.SheetNames.forEach(sheet => {
                const sheetData = XLSX.utils.sheet_to_json(
                  workbook.Sheets[sheet],
                  { header: 1 },
                );
                const sheetRange =
                  sheetData.length > 0
                    ? workbook.Sheets[sheet]["!ref"]
                    : "A1:B2";
                uploadedExcelData.push({
                  fileName: file.name,
                  sheetName: sheet,
                  range: sheetRange,
                  data: sheetData,
                });
              });
              if (this.props.sheetData) {
                const uploadXlsToTableCommand = new UploadXlsToTableCommand({
                  toggleTabAndToolPanelData:
                    this.props.toggleTabAndToolPanelData,
                  convertSectionTableToLinkedExcel,
                  saveTable: this._saveTable,
                  payload: {
                    activeComponentID: this.props.sheetData.id,
                    activeComponentType: this.props.sheetData.type,
                    oldSection: this.props.sheetData,
                    uploadedExcelData,
                    tableType: TABLE_TYPE.EXCEL_TABLE,
                  },
                  isChangingFileForSameTable: true,
                });
                this.props.executeCommand(uploadXlsToTableCommand);
              }
              this.setState({ errorMsg: "", fileName: file.name });
              const {
                data: {
                  attributes: { currentSheetName, excelSheets },
                },
              } = this.props.sheetData;
              const workSheets = [];
              excelSheets.forEach(sheet => {
                workSheets.push(sheet.sheetName);
              });
              this.setState({
                worksheetOptions: workSheets,
              });
              this.props.updateMultipleState({
                selectedRangeValue: "",
                selectedWorkSheet: currentSheetName,
              });
            }
          };
        }
      });
    }
  };

  _setRange = e => {
    this.setState({
      errorMsg: "",
    });
    this.props.setRangeValue(e);
  };

  render() {
    const { loader, loaderMsg, worksheetOptions, fileName } = this.state;
    const {
      selectedWorkSheet,
      selectedRangeValue,
      upatedExcelSheetTable,
      sheetData,
    } = this.props;
    const {
      data: {
        attributes: { connected, currentSheetName, rangeValue, autoTrim },
      },
    } = sheetData;
    if (loader) {
      return <Loader label={loaderMsg} fullScreen />;
    }
    let popupSpace = null;
    if (this.state.showTableExcelSizeLimitPopup) {
      popupSpace = (
        <TableExcelUploadSizeLimitPopup
          closePopup={() =>
            this.setState({ showTableExcelSizeLimitPopup: false })
          }
        />
      );
    }
    return (
      <Fragment>
        {popupSpace}
        <div className="excelsheet-selected-container">
          <Label className="excelsheet-selected-title">Selected sheet</Label>
          <div className="excelsheet-selected-sheet-name">
            <img src={spreadsheetIcon} alt="Empty Screen" /> {fileName}
            <span
              className="excelsheet-selected-sheet-change-icon"
              onKeyPress={() => null}
              role="button"
              tabIndex="0"
              onClick={this._selectNewFile}>
              <FontAwesomeIcon
                icon={["far", "edit"]}
                className="breadcrumb-bredcrumb-icon"
              />
              change
            </span>
          </div>
          <Label className="excelsheet-selected-title">Worksheet</Label>
          <div>
            <ReactSelect
              data-test="selectedsheetcomponent-selectedworksheet"
              options={worksheetOptions}
              value={selectedWorkSheet || currentSheetName}
              onChange={value => upatedExcelSheetTable(value.value)}
            />
          </div>
          {connected && selectedWorkSheet === currentSheetName && (
            <div>
              <Label className="excelsheet-selected-title">
                Select Range{" "}
                {autoTrim && (
                  <span className="excelsheet-star-mandatory-icon">*</span>
                )}
              </Label>
              <Input
                className={`form-control" ${
                  autoTrim ? "excelsheet-star-mandatory-field" : ""
                }`}
                data-test="selectedsheetcomponent-range"
                type="text"
                placeholder="Example A1:E5"
                value={selectedRangeValue || rangeValue}
                onChange={this._setRange}
              />
              {this.state.errorMsg && (
                <div
                  className="errormessages-wrapper"
                  data-test="errormessages-wrapper-row">
                  <div className="sync-bar" data-test="errormessages-section">
                    <div
                      className="requiredwitherr-icon"
                      data-test="errormessages-requiredwitherr-icon">
                      <FontAwesomeIcon icon={["far", "exclamation-triangle"]} />
                    </div>
                    <span
                      className="requiredwitherr-input"
                      data-test="errormessages-requiredwitherr-input">
                      {this.state.errorMsg}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}

          {this._getSynchButtonAndCheckbox()}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { googleSheetId, excelSheetId } = state.QuotationStore;
  const { gSheetRevvTables, currentGSheetTab, reUpdateWorkBooksOption } =
    state.GoogleSheetStore;
  const currentGSheet = gSheetRevvTables[googleSheetId];
  const sheetConnected = !!currentGSheet;
  const { firstRowAsHeader } = currentGSheetTab || {};

  const {
    document: {
      id: docID,
      created_by: { id: docOwnerID },
      template_type: typeOfTemplate,
    } = {},
    components,
  } = state.DocumentStore;

  const isTemplateTypeForm =
    typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;

  const mode = DOCUMENT_MODE.DOCUMENT;
  return {
    googleSheetSectionId: googleSheetId,
    currentGSheet,
    sheetConnected,
    currentGSheetTab,
    docOwnerID,
    reUpdateWorkBooksOption,
    firstRowAsHeader,
    components,
    excelSheetId,
    isTemplateTypeForm,
    docID,
    mode,
  };
};

const mapDispatchToProps = {
  fetchGoogleWorkSheet,
  makeEmptyRange,
  setWorkSheet,
  clearSelectedGSheetData,
  reUpdateWorkSheetOptions,
  updatefirstRowAsHeaderKey,
  updateDocumentComponentAction,
  executeCommand,
  toggleTabAndToolPanelData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectedSheetComponent);
